var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0643 30.86C30.5848 30.86 31.0874 30.9139 31.5854 30.9947L36.979 24.9954C34.87 24.0351 32.5322 23.4922 30.0643 23.4922C20.8837 23.4922 13.4126 30.9273 13.4126 40.0676C13.4126 49.2079 20.8837 56.643 30.0643 56.643C39.245 56.643 46.716 49.2079 46.716 40.0676C46.716 37.4875 46.1192 35.0465 45.0603 32.8658L39.1238 38.2055C39.2495 38.8067 39.3123 39.4304 39.3123 40.0676C39.3123 45.1515 35.1707 49.2752 30.0598 49.2752C24.949 49.2752 20.8074 45.1515 20.8074 40.0676C20.8074 34.9837 24.949 30.86 30.0598 30.86H30.0643Z",
    fill: "url(#paint0_linear_616_12713)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5203 29.2796C55.8068 29.9167 54.8241 30.1546 53.8953 29.9212L49.7312 28.8623C51.6517 32.1917 52.7466 36.0506 52.7286 40.1653C52.6793 52.0697 43.1486 62.0266 31.2039 62.6099C17.7784 63.265 6.75806 52.2895 7.42664 38.9224C8.01894 27.1033 17.9175 17.6489 29.8039 17.5143C33.8962 17.4695 37.7416 18.506 41.0711 20.3547L39.9628 16.1233C39.7205 15.2035 39.9583 14.2208 40.591 13.5073L41.5557 12.4259C37.5218 10.7567 33.0481 9.93557 28.3546 10.1958C13.2464 11.0304 0.992112 23.1457 0.05879 38.182C-1.0585 56.1754 13.9016 71.0592 31.9802 69.9419C47.1736 68.9996 59.3741 56.6555 60.0965 41.5159C60.3208 36.791 59.4324 32.2904 57.6824 28.2475L56.5203 29.284V29.2796Z",
    fill: "url(#paint1_linear_616_12713)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8145 10.9477L60.2621 9.68229L58.9518 1.17471C58.7723 0.0170289 57.323 -0.409248 56.5422 0.465741L43.6373 14.9412C43.3277 15.2867 43.2155 15.7623 43.3322 16.2066L44.6648 21.2815L28.8926 38.6556C28.2913 39.3242 28.3182 40.3518 28.9599 40.9845C29.6016 41.6216 30.6291 41.6441 31.2977 41.0383L48.6808 25.2616L53.7871 26.5628C54.2359 26.675 54.7115 26.5628 55.057 26.2532L69.5369 13.3393C70.4119 12.5585 69.9767 11.1182 68.8145 10.9432V10.9477Z",
    fill: "url(#paint2_linear_616_12713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_12713",
    x1: 15.5164,
    y1: 24.678,
    x2: 48.4368,
    y2: 51.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D437C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F9CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_616_12713",
    x1: 3.79845,
    y1: 12.2894,
    x2: 63.2354,
    y2: 60.6358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D437C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F9CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_616_12713",
    x1: 31.0836,
    y1: 1.48367,
    x2: 72.247,
    y2: 34.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D437C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowTarget);
export default __webpack_public_path__ + "static/media/icon-arrow-target.b65f3183a30aa55460b6e177edf792a3.svg";
export { ForwardRef as ReactComponent };